$(document).ready(function() {
    if ($('.slide-boxes__slideActive')[0]) {
        const scroller = $('.slide-boxes__slideActive');

        if (scroller.owlCarousel && $('.slide-boxes__slideItem').length > 1) {
            $(scroller).owlCarousel({
                margin: 1,
                items: 1,
                smartSpeed: 450,
                dots: true,
                nav: true,
                navRewind: false,
                loop: true,
                autoplay: true,
                autoplayTimeout: 10000,
                responsive: {
                    0: {
                        nav: $('.slide-boxes__slideItem').length > 1 ? true : false,
                        center: $('.slide-boxes__slideItem').length > 1 ? true : false,
                        loop: $('.slide-boxes__slideItem').length > 1 ? true : false,
                    },
                    768: {
                        items: 2,
                        margin: 30,
                        nav: $('.slide-boxes__slideItem').length > 2 ? true : false,
                        center: $('.slide-boxes__slideItem').length > 2 ? true : false,
                        loop: $('.slide-boxes__slideItem').length > 2 ? true : false,
                    },

                    1000: {
                        items: 3,
                        margin: 30,
                        nav: $('.slide-boxes__slideItem').length > 3 ? true : false,
                        center: $('.slide-boxes__slideItem').length > 3 ? true : false,
                        loop: $('.slide-boxes__slideItem').length > 3 ? true : false,
                    },
                },
            });

            var sourceWidth = $('.slide-boxes__slideActive .owl-dots').width();
            $('.slide-boxes__slideActive .owl-nav').width(sourceWidth);

            $(window).resize(function() {
                var sourceWidth = $('.slide-boxes__slideActive .owl-dots').width();
                $('.slide-boxes__slideActive .owl-nav').width(sourceWidth);
            });
        }
    }
});
